import { createTranslationObject } from '../helper';
import { Locale } from 'chaika-enums';
export const enTranslations = createTranslationObject(Locale.En);
